import React from "react";
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  ToggleButtonGroup,
  ToggleButton,
  Badge,
  Tooltip,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RefreshIcon from "@mui/icons-material/Refresh";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ScaleIcon from "@mui/icons-material/Scale";
import { Link } from "react-router-dom";

const ValuePageHeader = ({
  autoRefresh,
  onAutoRefreshToggle,
  onOpenKellyModal,
  onOpenBookieWeightsModal,
  onRefresh,
  backgroundLoading,
  onUnhideAll,
  hiddenBetsCount,
  onOpenHiddenBetsModal,
  evMode,
  onModeChange,
  hasCustomBookieWeights,
}) => (
  <Box
    sx={{
      display: "flex",
      gap: "16px",
      marginBottom: "16px",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-between",
    }}
  >
    <Button
      component={Link}
      to="/"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 1,
        mb: 1,
        p: 0,
        width: "max-content",
        textTransform: "none",
        textDecoration: "none",
        color: "inherit",
      }}
    >
      <ArrowBackIcon sx={{ height: "16px", width: "16px" }} />
      <Typography variant="h6" component="span">
        Back to Events
      </Typography>
    </Button>
    <Box
      sx={{
        display: "flex",
        alignItems: { xs: "flex-end", sm: "center" },
        flexDirection: { xs: "column", sm: "row" },
        gap: 2,
      }}
    >
      <ToggleButtonGroup
        value={evMode}
        exclusive
        onChange={onModeChange}
        size="small"
      >
        <ToggleButton value={true}>Fair Odds</ToggleButton>
        <ToggleButton value={false}>Market</ToggleButton>
      </ToggleButtonGroup>
      <Button onClick={onOpenKellyModal} variant="outlined" size="small">
        Kelly Settings
      </Button>
      <Tooltip title="Configure bookie weights for fair odds calculations">
        <Badge
          color="primary"
          variant="dot"
          invisible={!hasCustomBookieWeights}
        >
          <Button
            onClick={onOpenBookieWeightsModal}
            variant="outlined"
            size="small"
            startIcon={<ScaleIcon />}
          >
            Bookie Weights
          </Button>
        </Badge>
      </Tooltip>
      <Badge
        color="secondary"
        badgeContent={hiddenBetsCount}
        invisible={hiddenBetsCount === 0}
      >
        <Button
          onClick={onOpenHiddenBetsModal}
          variant="outlined"
          size="small"
          startIcon={<VisibilityOffIcon />}
        >
          Hidden Bets
        </Button>
      </Badge>
      {hiddenBetsCount > 0 && (
        <Button
          onClick={onUnhideAll}
          variant="outlined"
          size="small"
          startIcon={<VisibilityIcon />}
        >
          Unhide All ({hiddenBetsCount})
        </Button>
      )}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Button
          onClick={onRefresh}
          variant="outlined"
          size="small"
          startIcon={
            backgroundLoading ? <CircularProgress size={16} /> : <RefreshIcon />
          }
          disabled={backgroundLoading}
        >
          Refresh
        </Button>
        <Button
          onClick={onAutoRefreshToggle}
          variant="outlined"
          size="small"
          startIcon={
            autoRefresh && backgroundLoading ? (
              <CircularProgress size={16} />
            ) : (
              <AutorenewIcon />
            )
          }
          sx={{
            ...(autoRefresh && {
              backgroundColor: (theme) =>
                theme.palette.mode === "dark"
                  ? theme.palette.primary.dark
                  : theme.palette.primary.light,
              "&:hover": {
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark"
                    ? `${theme.palette.primary.dark}CC`
                    : `${theme.palette.primary.light}CC`,
              },
            }),
          }}
        >
          Auto-refresh (1m)
        </Button>
      </Box>
    </Box>
  </Box>
);

export default ValuePageHeader;
